const sectionContainer: { external: string; internal: string } = {
  external: 'mt-8 lg:mt-10',
  internal: 'py-12 lg:py-16',
}

const mobileFullContainer: { external: string; internal: string } = {
  external: 'mt-8 lg:mt-10 px-0 sm:px-0',
  internal: 'py-12 lg:py-16',
}

export { sectionContainer, mobileFullContainer }
